var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"archive-card",class:{unavailabe: !_vm.isAvailable}},[_c('div',{staticClass:"inner",style:({ 'background-image': 'url(' +  _vm.imgUrl + ')' })},[_c('h3',{staticClass:"centering"},[_vm._v(_vm._s(_vm.cardTitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }